var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.833984 15.6667V14.8333C0.833984 13.2862 1.44857 11.8025 2.54253 10.7085C3.63649 9.61458 5.12022 9 6.66732 9C8.21441 9 9.69815 9.61458 10.7921 10.7085C11.8861 11.8025 12.5007 13.2862 12.5007 14.8333V15.6667",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.834 10.6667C10.834 9.5616 11.273 8.50179 12.0544 7.72039C12.8358 6.93899 13.8956 6.5 15.0007 6.5C15.5478 6.5 16.0896 6.60777 16.5952 6.81717C17.1007 7.02656 17.56 7.33348 17.9469 7.72039C18.3338 8.1073 18.6408 8.56663 18.8501 9.07215C19.0595 9.57768 19.1673 10.1195 19.1673 10.6667V11.0833",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66732 9C7.55137 9 8.39922 8.64881 9.02434 8.02369C9.64946 7.39857 10.0007 6.55072 10.0007 5.66667C10.0007 4.78261 9.64946 3.93477 9.02434 3.30964C8.39922 2.68452 7.55137 2.33333 6.66732 2.33333C5.78326 2.33333 4.93542 2.68452 4.31029 3.30964C3.68517 3.93477 3.33398 4.78261 3.33398 5.66667C3.33398 6.55072 3.68517 7.39857 4.31029 8.02369C4.93542 8.64881 5.78326 9 6.66732 9ZM15.0007 6.5C15.6637 6.5 16.2996 6.23661 16.7684 5.76777C17.2373 5.29893 17.5007 4.66304 17.5007 4C17.5007 3.33696 17.2373 2.70107 16.7684 2.23223C16.2996 1.76339 15.6637 1.5 15.0007 1.5C14.3376 1.5 13.7017 1.76339 13.2329 2.23223C12.764 2.70107 12.5007 3.33696 12.5007 4C12.5007 4.66304 12.764 5.29893 13.2329 5.76777C13.7017 6.23661 14.3376 6.5 15.0007 6.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employeesIcon.30603fa0e1164e6201037c0fd3331019.svg";
export { ForwardRef as ReactComponent };